import { Autocomplete, TextField } from '@mui/material';
import { useState } from 'react';

import type { TimezoneSelectorProps } from './TimezoneSelector.types';

const TimezoneSelector = ({
  value,
  name,
  onChange,
  register
}: TimezoneSelectorProps) => {
  const timezones: string[] = Intl.supportedValuesOf('timeZone');
  const [selectedTimezone, setSelectedTimezone] = useState(value);

  const extractKey = <T extends { key?: React.Key }>(
    props: T
  ): [React.Key | undefined, Omit<T, 'key'>] => {
    const { key, ...rest } = props;
    return [key, rest];
  };

  const handleTimeZoneChange = (selectedValue: string) => {
    setSelectedTimezone(selectedValue);
    onChange(selectedValue, name);
  };

  return (
    <Autocomplete
      disablePortal
      slotProps={{
        listbox: {
          style: {
            maxHeight: '9.5rem',
            overflow: 'auto'
          }
        }
      }}
      autoHighlight
      sx={{ mb: 1.8 }}
      options={['Select Timezone', ...timezones]}
      value={selectedTimezone}
      onChange={(_, newValue) => handleTimeZoneChange(newValue ?? '')}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          {...(register ? register(`${name}_timezone`) : {})}
          name={`${name}_timezone`}
          onBlur={() => {
            if (!selectedTimezone) {
              setSelectedTimezone('Select Timezone');
            }
          }}
        />
      )}
      renderOption={(props, option) => {
        const [key, safeProps] = extractKey(props);
        return (
          <li key={key} {...safeProps}>
            {option}
          </li>
        );
      }}
    />
  );
};

export default TimezoneSelector;
